import React from 'react';
import s from './InvoicePopup.module.css';
import {ProductInReportType} from '../../types/TypesStore';

type Props = {
	product: ProductInReportType;
};
const ConfirmationTableRowItem: React.FC<Props> = ({product}) => {
	const {name, img, count} = product;
	return (
		<div className={s.gridRow}>
			<div className={s.columnItem}>
				<img src={img} alt={name} />
			</div>
			<div className={s.columnItem}>{name}</div>
			<div className={s.columnItem}>{count}</div>
		</div>
	);
};

export default ConfirmationTableRowItem;
